import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {DatePipe} from '@angular/common';

import {LogFile} from '../../../models/log/logfile';
import {LogFileService} from '../../../service/log/service-logfile';
import {Subject} from 'rxjs';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {CommandUtil} from '../../../global/commandutil';
@Component({
  templateUrl: './logfile.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LogFileComponent implements OnInit, AfterViewInit {
  public language = language;
  public dataList: LogFile[];
  public  onClose: Subject<boolean>;
  constructor( public logFileService: LogFileService,
               public datePipe: DatePipe,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef,
               public commandUtil: CommandUtil
  ) {
  }
  ngAfterViewInit() {

  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
  show(className: string, classPk: number)
  {
    this.logFileService.findAllByClassPkAndNam(className, classPk).subscribe( x => this.dataList = x);
  }
  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
}

